var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.5991 13.7988C76.1396 13.7988 78.1991 15.8583 78.1991 18.3988V45.9988C78.1991 48.5393 76.1396 50.5988 73.5991 50.5988V64.3988L59.7991 50.5988H32.1991C29.6586 50.5988 27.5991 48.5393 27.5991 45.9988V18.3988C27.5991 15.8583 29.6586 13.7988 32.1991 13.7988H73.5991ZM22.9991 36.7988V41.3988H19.5491C18.9139 41.3988 18.3991 41.9137 18.3991 42.5488V63.2488C18.3991 63.884 18.9139 64.3988 19.5491 64.3988H49.4491C50.0842 64.3988 50.5991 63.884 50.5991 63.2488V55.1988H55.1991V64.3988C55.1991 66.9393 53.1396 68.9988 50.5991 68.9988H27.5991L18.3991 78.1988V68.9988C15.8586 68.9988 13.7991 66.9393 13.7991 64.3988V41.3988C13.7991 38.8583 15.8586 36.7988 18.3991 36.7988H22.9991ZM32.1991 18.3988H73.5991V45.9988H68.9991V53.2934L61.7045 45.9988H32.1991V18.3988ZM55.1991 32.1988V36.7988H36.7991V32.1988H55.1991ZM68.9991 27.5988V22.9988H36.7991V27.5988H68.9991Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.819edfbf.svg";
export { ForwardRef as ReactComponent };